import welcome from './welcome';
import resources from './resources';

// ===========================|| MENU ITEMS ||=========================== //

const menuItems = (isShowEnviagoMenuItem) => ({ items: [welcome(isShowEnviagoMenuItem), resources] });

export default menuItems;
